// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, anyOf, maybe, objectOf } from "@altostra/type-validations";
import { any, boolean, number, string } from "@altostra/type-validations/lib/primitives";

/** Catalog field tokens are serialized as numbers in some environments and strings (e.g. "-1") in others. */
const catalogFieldToken = anyOf(number, string);

const catalogField = objectOf({
  name: string,
  token: catalogFieldToken,
  type: string,
  is_optional: maybe(boolean),
  is_required: maybe(boolean),
});

const importErrorEntry = objectOf({
  id: string,
  value: maybe(any),
});

const updateErrorEntry = objectOf({
  id: maybe(string),
  row: maybe(number),
  value: maybe(any),
});

export const isAppsBusinessSourcesResult = objectOf({
  business_sources: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      storage_size: number,
      num_items: maybe(number),
      fields: arrayOf(catalogField),
      updated_at: maybe(string),
      created_at: maybe(string),
      import_errors: maybe(arrayOf(importErrorEntry)),
      processing: maybe(boolean),
      update_error: maybe(updateErrorEntry),
    })
  ),
});
